import { createActions } from '../../../context';
import * as actions from './setupTradeRule.actions';

export const tradeRule = store => ({
    tradeRuleDetail: {
        courseSelected: "",
        ruleId: 0,
        tradeRuleId: 0,
        ruleName: '',
        discount: 0,
        numOfRounds: 0,
        isMonday: false,
        isTuesday: false,
        isWednesday: false,
        isThursday: false,
        isFriday: false,
        isSaturday: false,
        isSunday: false,
        startTime: "",
        endTime: "",
        startDate: new Date(),
        endDate: new Date(),
        isEnabled: true,
        rateTypeLabel: "",
        teesheetNotes: "",
        isRuleNameNotExist: false,
        isValidTradeRuleDetails: false,
        ruleErrorMessage: '',
        listTradeRuleCourseConfiguration: [],
        tradeRuleCourseConfigurationExistList: [],
        isValidTradeRuleCourseConfiguration: false,
    },
    tradeRuleCourseList: {
        pagination: {
            currentPage: 1,
            pageSize: 10,
            pagesCount: 1,
            itemsCount: 0
        },
        filters: {
            name: '',
            provider: '',
            status: 1,
            isClassReq: true,
        },
        items: [],
        selectedCourses: [],
        selectedCourseConfiguration: [],
        selectedTradeRuleCoursesCount: 0,
        allSelected: false,
        isValidateCheckConfig: false,
    },
    tradeRuleCourseListProviders: [],
    selectedCourseClassInfomation: null,
    isLoadingSelectedCourseClassInfomation: false,
    actions: createActions(actions)(store)
});